import { Redirect } from 'app/routx-router'
import React from 'react'

export const Component: React.FC = () => {
  return <Redirect to='/farms' replace />
}

export default Component
